import { render, staticRenderFns } from "./EventViewKiosk.vue?vue&type=template&id=41427f4e&"
import script from "./EventViewKiosk.vue?vue&type=script&lang=js&"
export * from "./EventViewKiosk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports